module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Regular.4a50c417519b2de660e552aab2c393e2.ttf";